import api from './api';

// The shared axios instance has baseURL '/api'; the backend mounts the v1
// router at '/api/v1', so every path here is prefixed with '/v1'.
export const analysisApi = {
  uploadLease: (form) => api.post('/v1/pdf/upload', form).then((r) => r.data),
  getDetails: (id) => api.post(`/v1/analysis/details/${id}`).then((r) => r.data),
  confirmDetails: (id) => api.post(`/v1/analysis/details/${id}/confirm`).then((r) => r.data),
  getContextQuestions: () => api.get('/v1/analysis/context-questions').then((r) => r.data),
  saveContext: (id, answers) => api.post(`/v1/analysis/context/${id}`, answers).then((r) => r.data),
  analyze: (id) => api.post(`/v1/analysis/analyze/${id}`).then((r) => r.data),
  getStatus: (id) => api.get(`/v1/analysis/status/${id}`).then((r) => r.data),
  getDocument: (id) => api.get(`/v1/pdf/documents/${id}`).then((r) => r.data),
  getDocuments: () => api.get('/v1/pdf/documents').then((r) => r.data),
  deleteDocument: (id) => api.delete(`/v1/pdf/documents/${id}`),
  // The report endpoint requires a Bearer token, so a plain <a href> download
  // (browser navigation, no Authorization header) 401s. Fetch it as a blob
  // through the authenticated axios instance and save via an object URL.
  downloadReport: async (id) => {
    const res = await api.get(`/v1/analysis/report/${id}.pdf`, { responseType: 'blob' })
    const url = URL.createObjectURL(res.data)
    const a = document.createElement('a')
    a.href = url
    a.download = `lease-report-${id}.pdf`
    document.body.appendChild(a)
    a.click()
    a.remove()
    URL.revokeObjectURL(url)
  },
  emailReport: (id) => api.post(`/v1/analysis/report/${id}/email`).then((r) => r.data),
  // Same authenticated-blob pattern as downloadReport, for the landlord
  // redline PDF (a plain <a href> would 401 — no Authorization header).
  downloadRedline: async (id) => {
    const res = await api.get(`/v1/analysis/report/${id}/redline.pdf`, { responseType: 'blob' })
    const url = URL.createObjectURL(res.data)
    const a = document.createElement('a')
    a.href = url
    a.download = `lease-redline-${id}.pdf`
    document.body.appendChild(a)
    a.click()
    a.remove()
    URL.revokeObjectURL(url)
  },
};
